export const validateTransferProofs = (files) => {
  if (!files.length || files.length > 5) return 'Pilih 1–5 file bukti transfer.'
  if (files.some((file) => !file.size || file.size > 8 * 1024 * 1024)) return 'File kosong/tidak terbaca atau melebihi 8 MB. Pilih ulang dari penyimpanan HP.'
  if (files.reduce((total, file) => total + file.size, 0) > 12 * 1024 * 1024) return 'Total file maksimal 12 MB.'
  return ''
}

// A lost response is not evidence that the server rolled back the upload.
// Only GET is retried here; never automatically repeat a payment/upload POST.
export const saveTransferProofs = async (api, settlementId, paymentId, files, onProgress) => {
  const message = validateTransferProofs(files)
  if (message) throw new Error(message)
  try {
    return await api.savePaymentTransfer(settlementId, paymentId, files, onProgress)
  } catch (error) {
    if (!error.response || error.response.status >= 500 || error.response.status === 422) {
      try {
        const status = await api.paymentTransferStatus(settlementId, paymentId)
        if (status.data?.data?.payment?.status === 'paid') return { ...status, transferStatusRecovered: true }
      } catch (statusError) { /* Keep the upload outcome unknown until the server can be reached. */ }
      if (error.response?.status === 422) throw error
      throw new Error('Koneksi terputus; hasil upload belum dapat dipastikan. Jangan transfer uang lagi. Klik Periksa Status Transfer. Jika masih approved, periksa bank dan unggah slip yang sama setelah koneksi pulih.')
    }
    throw error
  }
}
